import Axios from "@app/api/axios";
import config from "@src/config";
import { BRICK_ID } from "@utils/constant";
import { parseQueryParams } from "@utils/utils";
import { accountsBody, accountDetailsBody } from "../constants";

const mySavings = async () => {
  const response = await fetch("data/my-savings.json");
  if (response.error) {
    throw new Error(response.error);
  }
  return await response.json();
};

export default mySavings;

export const collectAverageInsuranceReturns = async (duration) => {
  const response = await fetch(`data/${duration}.json`);
  if (response.error) {
    throw new Error(response.error);
  }
  return await response.json();
};

export const getAccounts = async (
  brickId,
  clearCacheEntry = false,
  maxAge = 60 * 60 * 1000
) => {
  const params = [[BRICK_ID, brickId]];
  const body = JSON.stringify(accountsBody);

  try {
    const response = await Axios.post(
      `${config.BASE_URL}accounts${parseQueryParams(params)}`,
      body,
      {
        cache: {
          maxAge,
        },
        clearCacheEntry,
      }
    );
    const { data = {} } = response;
    return data;
  } catch (err) {
    //catch error
  }
};

export const getAccountDetails = async (
  brickId,
  accountNo,
  clearCacheEntry = false,
  maxAge = 60 * 60 * 1000
) => {
  const params = [[BRICK_ID, brickId]];
  const body = JSON.stringify({
    fields: accountDetailsBody,
    filters: [{ brickId, accountNo }],
  });

  try {
    const response = await Axios.post(
      `${config.BASE_URL}account-details${parseQueryParams(params)}`,
      body,
      {
        cache: {
          maxAge,
        },
        clearCacheEntry,
      }
    );
    const { data = {} } = response;
    return data;
  } catch (err) {
    //catch error
  }
};

export const getAccountById = async (userId, accountId, aws) => {
  const request = await aws.sign(`${config.BASE_URL}accounts/${userId}`, {
    method: "POST",
    body: JSON.stringify({
      accountId: accountId,
      fields: accountsBody,
    }),
  });

  try {
    const response = await fetch(request);
    return await response.json();
  } catch (err) {
    //catch error
  }
};

export const getRecurring = async (brickId) => {
  const body = JSON.stringify({
    fields: [
      "BrickId",
      "BusinessDate",
      "CreatedDate",
      "PeriodicityCode",
      "IsRecurringOrder",
      "Amount",
      "TransferReceiver",
      "AccountId",
      "StatusKey",
    ],
  });

  try {
    const response = await Axios.post(
      `${config.BASE_URL}recurring?brickId=${brickId}`,
      body
    );
    const { data = {} } = response;
    return data;
  } catch (err) {
    if (err.response) {
      // client received an error response
      return {
        status: err.response["status"],
        message: err.response.data,
      };
    } else if (err.request) {
      // client did not receive a reponse
      return {
        status: err.request["status"],
        message: err.request.data,
      };
    } else {
      // the token has probably expired
      return err;
    }
  }
};
